import type { ReactNode } from 'react'
import { getScoreConfig, getTagFromPowerForm } from '../../../../components/know-why/utils'
import { GradientStrip } from '../../../../components/ui-components/GradientStrip'
import { EliteScoreTrends } from '../../../../types/mutual-fund-detail.types'
import { mapRatingToPowerForm } from '../utils/mapRatingToPowerFormUtils'

export function resolveEliteScoreTrendFromPerformanceTag(
  scoreLabel: string | null | undefined
): EliteScoreTrends {
  const normalizedLabel = (scoreLabel ?? '').trim().toLowerCase()
  if (normalizedLabel === 'great') {
    return EliteScoreTrends.GREAT
  }
  if (normalizedLabel === 'good') {
    return EliteScoreTrends.GOOD
  }
  if (normalizedLabel === 'average') {
    return EliteScoreTrends.AVERAGE
  }
  if (normalizedLabel === 'bad') {
    return EliteScoreTrends.BAD
  }
  return EliteScoreTrends.GOOD
}

export function resolveRankStripTagFromPowerRating(
  powerRating: string | null | undefined
): EliteScoreTrends {
  const powerForm = mapRatingToPowerForm(powerRating ?? '')
  if (powerForm) {
    return getTagFromPowerForm(powerForm)
  }
  return EliteScoreTrends.GREAT
}

export function PlanRecommendationReasonHighlightStrip({
  tag,
  children
}: {
  tag: EliteScoreTrends
  children: ReactNode
}) {
  const config = getScoreConfig(tag)

  return (
    <GradientStrip type={config.gradientStripType} className="!p-4 !pt-[13px] !rounded-[12px]">
      {children}
    </GradientStrip>
  )
}
